<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR CONTEÚDO' : 'NOVO CONTEÚDO'" titleIcon="fas fa-edit">

            <div v-if="modoEdicao && !carregado" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>

            <el-form v-else label-position="top" :model="dados" ref="dados" @submit.native.prevent="salvar">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="10">
                        <el-form-item label="Descrição" prop="descricao" :rules="[$requiredBlur]">
                            <el-input v-model="dados.descricao" maxlength="191" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Grupo de Conteúdo">
                            <el-select v-model="dados.grupo_conteudo_id" filterable clearable placeholder="(nenhum)" style="width: 100%;">
                                <el-option v-for="g in gruposConteudo" :key="g.id" :label="g.nome" :value="g.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="4">
                        <el-form-item label="Ordem">
                            <el-input-number v-model="dados.ordem" :min="0" :step="1" style="width: 100%;"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="4">
                        <el-form-item label="Situação">
                            <el-select v-model="dados.situacao" style="width: 100%;">
                                <el-option :value="true" label="ATIVO"></el-option>
                                <el-option :value="false" label="INATIVO"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Habilidades">
                            <el-input type="textarea" :rows="3" v-model="dados.habilidades" placeholder="Habilidades trabalhadas neste conteúdo"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <label style="font-weight: bold;">Itens que compõem o conteúdo</label>
                        <div style="color: #909399; font-size: 12px; margin-bottom: 8px;">
                            Cada item é um tópico/subconteúdo que integra este conteúdo.
                        </div>

                        <el-row :gutter="10" v-for="(it, idx) in dados.itens" :key="idx" class="u-mb-10">
                            <el-col :xs="20" :sm="22">
                                <el-input v-model="it.descricao" placeholder="Descrição do item"></el-input>
                            </el-col>
                            <el-col :xs="4" :sm="2" class="u-text-center">
                                <el-button type="danger" icon="el-icon-delete" size="mini" plain @click="removerItem(idx)"></el-button>
                            </el-col>
                        </el-row>

                        <el-button type="primary" size="mini" plain icon="el-icon-plus" @click="adicionarItem">Adicionar item</el-button>
                    </el-col>
                </el-row>

                <el-row class="u-mt-15">
                    <el-col :xs="24" class="u-text-right">
                        <router-link to="/admin/conteudo-referencia">
                            <el-button>VOLTAR</el-button>
                        </router-link>
                        <el-button class="u-ml-10" type="primary" native-type="submit">SALVAR</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        dados: { descricao: '', grupo_conteudo_id: null, habilidades: '', ordem: 0, situacao: true, itens: [] },
        gruposConteudo: [],
        modoEdicao: false,
        carregado: false
    }),
    mounted () {
        this.carregarGrupos()
        if (this.$route.params.id) {
            this.modoEdicao = true
            this.carregar(this.$route.params.id)
        }
    },
    methods: {
        carregarGrupos () {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/grupo-conteudo/getAll`, this.$store.getters.getHeaderAuth)
                .then(r => { this.gruposConteudo = Array.isArray(r.data) ? r.data : [] })
                .catch(e => this.$store.commit('throwException', e))
        },
        adicionarItem () {
            this.dados.itens.push({ descricao: '' })
        },
        removerItem (idx) {
            this.dados.itens.splice(idx, 1)
        },
        carregar (id) {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/conteudo-referencia/getById/${id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const reg = r.data || {}
                this.dados.descricao = reg.descricao || ''
                this.dados.grupo_conteudo_id = reg.grupo_conteudo_id || null
                this.dados.habilidades = reg.habilidades || ''
                this.dados.ordem = reg.ordem || 0
                this.dados.situacao = reg.situacao === false ? false : true
                this.dados.itens = Array.isArray(reg.itens) ? reg.itens.map(i => ({ descricao: i.descricao || '' })) : []
                this.carregado = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) {
                    window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' })
                    return
                }
                window.eventBus.$emit('loading', true)
                const url = this.modoEdicao
                    ? `${this.$store.state.config.baseUrlApi}/api/conteudo-referencia/update/${this.$route.params.id}`
                    : `${this.$store.state.config.baseUrlApi}/api/conteudo-referencia/store`
                this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Salvo com sucesso.', type: 'success' })
                    this.$router.push('/admin/conteudo-referencia')
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        }
    }
}
</script>
